import React,{useState} from 'react'
import Sets from "../../maxillofacial/desktop/Sets"
import {dataGenerator} from "./data.js";
import i18n from "i18next";

const MicroPlatingSets = (props) => {
	const [data, setData] = useState(dataGenerator(i18n.language))
	i18n.on('languageChanged', function(lng) {	
		setData(dataGenerator(lng))
	})
	return (
		<Sets
			title={"microPlatingSystem.products.4.name"}
			navigate={"microplating_system"}
			subtitle={"microPlatingSystem.products.4.description"}
			sectionTitles={["microPlatingSystem.sets.titles.1"]}
			titleExtended={["microPlatingSystem.sets.titles_extended.1"]}
			sectionData={[data.dataSection_1]}
		/>
	)
}

export default (MicroPlatingSets)